import { Version } from '@repo/toolkit/types'
import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import {
  JourneyPlace,
  JourneyPlaceFilters,
  JourneyPlaceSort
} from '../../lib/types/models/journey-place/journey-place'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getJourneyPlaces(
  input: PaginationRequest<JourneyPlaceFilters, string, Version, JourneyPlaceSort> = {}
) {
  if (!input.sort) input.sort = { name: 'asc' }
  return restApiClient
    .url(encodeNestedObject(constructApiUrl(API.journeyPlaces.getAll.url, null), input))
    .get<PaginationResponse<JourneyPlace>>()
}
